import { render, staticRenderFns } from "./WarehouseBaseData.vue?vue&type=template&id=206c09a7"
import script from "./WarehouseBaseData.vue?vue&type=script&lang=js"
export * from "./WarehouseBaseData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports